<template>
    <div class="kundenportal-product-combo">
        <template v-if="showMatNr">
            <div class="kpc__product__label">{{ $t('kundenportal-product-combos.matnr') }}</div>
            <div>{{ product.matnr }}</div>
        </template>
        <div v-else><!-- Grid placeholder --></div>
        <div v-if="!omitApplicationColumn" class="kpc__product__label">{{ $t('kundenportal-product-combos.recommended_application') }}</div>
        <div v-if="!omitApplicationColumn">{{ product.recommended_application.join(", ") }}</div>
        <div class="kpc__product__label">{{ $t('kundenportal-product-combos.dimension') }}</div>
        <div>{{ product.format }}&nbsp;x&nbsp;{{ product.height }}<br v-if="product.kante">{{ product.kante }}</div>
        <div class="kpc__product__label">{{ $t('kundenportal-product-combos.quantities_stock') }}</div>
        <div v-if="(product.moq_stock && product.moq_stock.length > 0) || (product.inc_stock && product.inc_stock.length > 0)">
            {{ product.moq_stock || 0 }}
            /
            {{ product.inc_stock || 0 }}
        </div>
        <div v-else><!-- Grid placeholder --></div>
        <div class="kpc__product__label">{{ $t('kundenportal-product-combos.quantities_production') }}</div>
        <div v-if="(product.moq_prod && product.moq_prod.length > 0) || (product.inc_prod && product.inc_prod.length > 0)">
            {{ product.moq_prod || 0 }}
            /
            {{ product.inc_prod || 0 }}
        </div>
        <div v-else><!-- Grid placeholder --></div>
        <div class="kpc__product__label">
            <div>{{ $t('kundenportal-product-combos.check_title') }}</div>
            <global-tooltip><p class="check-notice" v-html="$t('kundenportal-product-combos.check_tooltip')"/></global-tooltip>
        </div>
        <form v-if="product.allow_check" @submit="(e) => checkStock(e)" class="kpc__check__form">
            <input v-model="input" size="5" maxlength="5" class="kpc__check__input form__input form__input--text">
            <span v-if="!input" class="kpc__check__hint">{{ $t('kundenportal-product-combos.check_hint') }}</span>
            <button v-if="input && !apiResult" class="kpc__check__btn button button--secondary">{{
                    $t('kundenportal-product-combos.do_check')
                }}
            </button>
            <template v-if="apiResult">
                <div class="kpc__check__result">
                    <div class="kpc__check__status"
                         :class="{
                            'kpc__check__status--green': apiResult.status === '🟢',
                            'kpc__check__status--yellow': apiResult.status === '🟡',
                            'kpc__check__status--red': apiResult.status === '🔴'
                    }"></div>
                    <div v-if="apiResult.status === '🟡' || apiResult.status === '🔴'">
                        <div v-if="'w' in apiResult">{{
                                $t('kundenportal-product-combos.check_result_week')
                            }} {{ weekNumber(0) }}: {{ apiResult.w }} {{ piecesLabelW }}
                        </div>
                        <div v-if="'w1' in apiResult">{{
                                $t('kundenportal-product-combos.check_result_week')
                            }} {{ weekNumber(1) }}: {{ apiResult.w1 }} {{ piecesLabelW1 }}
                        </div>
                        <div v-if="'w2' in apiResult">{{
                                $t('kundenportal-product-combos.check_result_week')
                            }} {{ weekNumber(2) }}: {{ apiResult.w2 }} {{ piecesLabelW2 }}
                        </div>
                    </div>
                    <div>{{ apiResult.message }}</div>
                </div>
            </template>
        </form>
        <div v-else>{{ $t('kundenportal-product-combos.no_check') }}</div>
    </div>
</template>

<script>
import GlobalTooltip from "@global/global-elements/global-tooltip/global-tooltip.vue";
import {tracking_events} from "@utilities/track-abstract/track-abstract";
import {getCalendarWeek} from "@utilities/sal-calendar-week/sal-calendar-week";

export default {
    name: "kundenportal-product-combo",
    components: {GlobalTooltip},
    props: {
        product: null,
        omitDecorColum: false,
        omitStructureColum: false,
        omitProductColum: false,
        omitRawboardColum: true,
        omitApplicationColumn: false,
    },
    data: () => {
        return {
            input: '',
            apiResult: null
        }
    },
    watch: {
        input: function(val) {
            this.apiResult = null;
        }
    },
    computed: {
        showMatNr: function() {
            return this.product.matnr;
        },
        piecesLabelW() {
            if (this.apiResult && typeof this.apiResult.w === 'number') {
                return this.$t('kundenportal-product-combos.pieces');
            }
        },
        piecesLabelW1() {
            if (this.apiResult && typeof this.apiResult.w1 === 'number') {
                return this.$t('kundenportal-product-combos.pieces');
            }
        },
        piecesLabelW2() {
            if (this.apiResult && typeof this.apiResult.w2 === 'number') {
                return this.$t('kundenportal-product-combos.pieces');
            }
        },
    },
    methods: {
        weekNumber(offsetWeek) {
            return ('' + getCalendarWeek(new Date(), offsetWeek)).padStart(2, '0');
        },
        checkStock(e) {
            if (this.input && !this.apiResult) {
                const num = parseInt(this.input);
                if (this.product.matnr && num > 0) {
                    this.$http.get(this.$store.state.stockApi + '&tx_epim_efapi[num]=' + num + '&tx_epim_efapi[article]=' + this.product.matnr)
                        .then(response => {
                            this.apiResult = response.data;

                            track_abstract.trigger_event(tracking_events.kundenportal_product_combo_stockcheck, {
                                dekor: this.product.title_d ? this.product.title_d : '',
                                struktur: this.product.title_s ? this.product.title_s : '',
                                produkt: this.product.title_t ? this.product.title_t : '',
                                rawboard: this.product.title_r ? this.product.title_r : '',
                                matnr: this.product.matnr || '-',
                                query: num,
                                result: this.apiResult.status
                            });
                        });
                }
            }
            // STOP IT!
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }
}
</script>
